import { render, staticRenderFns } from "./csscTable.vue?vue&type=template&id=19fc528b&"
import script from "./csscTable.vue?vue&type=script&lang=js&"
export * from "./csscTable.vue?vue&type=script&lang=js&"
import style0 from "./csscTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports